// extracted by mini-css-extract-plugin
export default {"recos":"E5-z","productCardOverride":"F5-z","rowHasBadge":"G5-z"};